import {Howl, Howler} from 'howler';
import AppState from '../../AppState';

export default class Dial {

    constructor(jsonObj, specificParameter) {

        this.jsonObj = jsonObj
        this.specificParameter = specificParameter

        this.isLoad = false

        this.howl = null
    }

    updateSpecificParameters(specificParameter) {
        this.specificParameter = specificParameter
    }

    load(dialEndCb) {
        this.loadAudio(dialEndCb)
        return this.loadPhonem()
                .then(() => {
                    this.isLoad = true
                })
    }

    loadAudio(dialEndCb) {
        var sound = new Howl({
            src: [this.getAssetPath() + ".mp3"]
        });

        if(sound) {
            sound.on('end', function() {
                dialEndCb()
            })

            this.howl = sound
        }
    }

    loadPhonem() {
        return fetch(this.getAssetPath() + ".json")
            .then(response => response.text())
            .then(json => this.phonem = json)
    }

    getText() {
        return this.jsonObj.Text;
    }

    getPhonem() {
        return this.phonem
    }

    getAttitude() {
        return this.jsonObj.attitude
    }

    getKey() {
        return this.jsonObj.key;
    }

    getAssetPath() {
        return window.CONFIG.root + this.jsonObj.path
    }

    isPlaying() {
        this.howl.playing()
    }

    start() {
        this.howl.play()

        if(AppState.debugMode) {
          setTimeout(() => {

            this.stop()
          }, 500)
        }
    }

    stop() {
        this.howl.stop()
    }
}